import styled from "@emotion/styled";

import { color } from "metabase/lib/colors";

export const InfoText = styled.div`
  color: ${color("text-medium")};
`;
